// Test IDs for the Publish History aggregate page.

export const PUBLISH_HISTORY = {
  navLink: 'home-nav-publish-history-link',
  loading: 'publish-history-loading',
  emptyState: 'publish-history-empty-state',
  appFilterSelect: 'publish-history-app-filter-select',
  statusFilterSelect: 'publish-history-status-filter-select',
  table: 'publish-history-table',
  row: (id) => `publish-history-row-${id}`,
  retryBtn: (id) => `publish-history-retry-btn-${id}`,
};
